import axios from "axios";
import { stringify } from "qs";

const { is_mobile_site, language_switch, site } = window.tg;

/**
 * @param {string} establishmentId
 * @param {string} customerId
 * @param {string} startDate
 * @param {string} endDate
 */

function get_recommended_listings(establishmentId, customerId, startDate, endDate) {
    // Check if should display similar establishments, only if identifier is here
    let recommendedAjaxElement = document.querySelector('.js-recommended-ajax');

    if (recommendedAjaxElement !== null) {
        let ga_category = recommendedAjaxElement.getAttribute('data-ga-category');
        let ga_action = recommendedAjaxElement.getAttribute('data-ga-action');

        axios({
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            method: 'post',
            url: '/accomm/src/ajax/get_similar_establishment_snippets.php',
            data: stringify({
                'establishment_id': establishmentId,
                'start_date': startDate,
                'end_date': endDate,
                'customer_id': customerId,
                'is_mobile': is_mobile_site,
                'theme': site,
                'lang': language_switch,
                'ga_action': ga_action,
                'ga_category': ga_category
            })
        }).then(function (result) {

            if (result.data.num_results > 0) {
                let recommendedPlaceholder = document.querySelector('.js-recommended-placeholder');
                recommendedAjaxElement.innerHTML = result.data.html;
                recommendedAjaxElement.classList.remove('d-none');
                recommendedPlaceholder.parentNode.removeChild(recommendedPlaceholder);
            } else {
                let recommendedSection = document.querySelector('.js-recommended-block');
                recommendedSection.parentNode.removeChild(recommendedSection);
            }
        });
    }
}

export { get_recommended_listings };
